export class FrameData {
  public data: Uint8ClampedArray;
  public width: number;
  public height: number;
  constructor(data: Uint8ClampedArray, width: number, height: number) {
    this.data = data;
    this.width = width;
    this.height = height;
  }
}



// WEBPACK FOOTER //
// ./src/constants/FrameData.ts